import "./Suppliers.css";
import Hero from "./hero/Hero";
import OurSuppliers from "./our-suppliers/OurSuppliers";
import SuppliersPart from "./suppliersPart/SuppliersPart";
import SuppliersSEO from "../../components/SEO/SuppliersSEO";

const Suppliers = () => {
  return (
    <>
      <SuppliersSEO />
      <Hero />
      <OurSuppliers />
      <SuppliersPart />
    </>
  );
};

export default Suppliers;
